'use strict';
/**
 * Utility function to calculate commercially rounded number of pieces
   for a given total weight and the article's weight per piece value.
   However, does not round down to zero for positive weight to avoid
   showing in the panel "0 pieces" but positive weight.
   Returns zero if not both are provided and greater zero.
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.calculatePiecesFromWeight = calculatePiecesFromWeight;
exports.calculateWeightFromPieces = calculateWeightFromPieces;
exports.preservePrecision = preservePrecision;

function calculatePiecesFromWeight(totalWeight, weightPerPieceValue) {
  // Note: We should not round down to zero, because otherwise we would have
  // "0 pieces" but a positive weight.
  return totalWeight > 0 && weightPerPieceValue > 0 ? Math.max(1, Math.round(totalWeight / weightPerPieceValue)) : 0;
}
/**
 * Util function which takes some piece number as input and provides the corresponding weight in kg. Ignores
 * decimal places when considering the input (which is the point of pieces, after all)
 * @param pieces the number of pieces. Will be truncated.
 * @param weightPerPieceValue weight of a piece in kg.
 * @returns {number} the total weight of {piece} amount of pieces.
 */


function calculateWeightFromPieces(pieces, weightPerPieceValue) {
  var truncatedPieces = Math.trunc(pieces);
  return truncatedPieces > 0 && weightPerPieceValue > 0 ? preservePrecision(truncatedPieces, weightPerPieceValue, truncatedPieces * weightPerPieceValue) : 0;
}
/**
 * Utility function to preserve the (maximum) precision (of both operands
   a and b) and not get machine precision issues like 1.02 * 2 = 2.039999999
   when adding or multiplying the weight.
   Use for "a + b = c" and "a * b = c" (but not division, obviously).
 */


function preservePrecision(a, b, c) {
  var aString = a.toString();
  var aStringParts = (aString + "").split(".");
  var aPrecision = aStringParts.length > 1 ? aStringParts[1].length : 0;
  var bString = b.toString();
  var bStringParts = (bString + "").split(".");
  var bPrecision = bStringParts.length > 1 ? bStringParts[1].length : 0;
  var maxPrecision = Math.max(aPrecision, bPrecision);
  var cString = c > 0 ? c.toFixed(maxPrecision) : "0";
  return parseFloat(cString);
}